import type { PropsWithChildren } from "react";

import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import type {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";
import { ConfluenceTemplatesUnifiedPageTemplate as ConfluenceTemplatesUnifiedPageTemplate } from "@/templates/software/confluence/templates/confluence-templates-page/src/confluence-templates-unified-page.template.tsx";

export type ConfluenceTemplateCategoryPageTemplateProps = PropsWithChildren<{
    templates?: Template[];
    partnerTemplates?: Template[];
    collections?: TemplateCollection[];
    categories?: TemplateCategory[];
}>;

export const ConfluenceTemplateCategoryPageTemplate = ({
    templates,
    partnerTemplates,
    collections,
    categories
}: ConfluenceTemplateCategoryPageTemplateProps) => {
    return (
        <ConfluenceTemplatesUnifiedPageTemplate
            templates={templates}
            categories={categories}
            collections={collections}
            partnerTemplates={partnerTemplates}
        />
    );
};
